import MentorChromeActions from './MentorChromeActions';

const MentorSessionsChrome = () => (
    <div className="card border-0 rounded-3 px-3 py-2 bg-white d-flex flex-row align-items-center justify-content-between shadow-sm mb-3">
        <div className="breadcrumb mb-0 align-items-center font-12 fw-medium text-secondary">
            Mentorship Module &nbsp;›&nbsp;{' '}
            <span className="text-dark fw-bold" id="bc-cur">
                Sessions
            </span>
        </div>
        <MentorChromeActions />
    </div>
);

export default MentorSessionsChrome;
